export const getArcDataStartingAngle = (layer: any) => {
  if (!layer.arcData) {
    console.warn('ArcData: Starting Angle Error');
  }

  return Number(layer.arcData.startingAngle.toFixed(4));
};
